export default {"src":"/_next/static/media/ChatIcon.20aee076.svg","height":15,"width":16,"blurWidth":0,"blurHeight":0};